module.exports = __webpack_public_path__ + "img/图片5.ac17d144.png";